import React from "react";

const RibbonRow = (props) => {
  const { title } = props || {};

  return (
    <div className="ribbon-row-holder">
      <div className="ribbon-row-title">
        <h6>{title}</h6>
      </div>
    </div>
  );
};

export default RibbonRow;
